/**
 * A `DataTableHeaderCell` wrapped as a `@dnd-kit` sortable reorder target. Only rendered for
 * reorderable columns inside the preset's `DndContext` + `SortableContext`. `attributes` are
 * deliberately dropped (see `data-table-header-cell.tsx`) — pointer `listeners` only.
 *
 * Its own file so `data-table-header-cell.tsx` exports a single component (fast-refresh purity /
 * `single-component-export`).
 */
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { RowData } from '@tanstack/react-table'

import { DataTableHeaderCell, type DataTableHeaderCellProps } from './data-table-header-cell'

export const SortableHeaderCell = <TData extends RowData>(
  props: DataTableHeaderCellProps<TData>,
) => {
  const { listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.header.column.id,
  })

  return (
    <DataTableHeaderCell
      {...props}
      dnd={{
        setNodeRef,
        listeners,
        style: { transform: CSS.Transform.toString(transform), transition },
        isDragging,
      }}
    />
  )
}
